export const QUERY_INPUT_PLACEHOLDER = 'What would you like to research?';
export const THREAD_INPUT_PLACEHOLDER = 'Ask Deep Research';

export const initialValues = {
  query: '',
};

// URLs can only contain so many characters before a browser may break,
// so we should make sure we aren't sending too many in our request.
// Arbitrarily limited here to support Chrome's limit of roughly 2,083
export const MAX_CHAR_COUNT = 2000;
export const MIN_CHAR_COUNT = 3;
